import { render, staticRenderFns } from "./userDetailIntegral.vue?vue&type=template&id=f34423ea&scoped=true"
import script from "./userDetailIntegral.vue?vue&type=script&lang=js"
export * from "./userDetailIntegral.vue?vue&type=script&lang=js"
import style0 from "./userDetailIntegral.vue?vue&type=style&index=0&id=f34423ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34423ea",
  null
  
)

export default component.exports